import { html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { getGlobalStyleSheets } from '../../global-styles';

import { BannerTags, BannerEvents, type AtlAnnouncementBannerProps } from './banners.types.ts';

import { IconEnums, type AtlAriaIconProps  } from '../icon';
import { ButtonEnums } from '../button';

@customElement(BannerTags.AnnouncementBanner)
export class AtlAnnouncementBanner
   extends LitElement
   implements AtlAnnouncementBannerProps
{
   static styles = [...getGlobalStyleSheets()];

   @property({ attribute: 'banner-title', type: String })
   bannerTitle?: string;

   @property({ attribute: 'show-icon', type: Boolean })
   showIcon?: boolean;

   @property({ attribute: 'icon-name', type: String })
   iconName?: string;

   @property({ attribute: 'icon-size', type: String })
   iconSize?: IconEnums.IconSizes;

   @property({ attribute: 'show-cta-button', type: Boolean })
   showCtaButton?: boolean;

   @property({ attribute: 'cta-button-text', type: String })
   ctaButtonText?: string;

   private _renderIcon = () => {
      if (!this.showIcon) return nothing;

      return html`
         <atlantis-icon
            iconSource=${IconEnums.IconSource.FontAwesome}
            iconSize=${this.iconSize || IconEnums.IconSizes.Zoom2x}
            name=${this.iconName || 'bullhorn'}
            iconClassName="banner-icon"
            .icon-aria-settings=${{
               ariaHidden: true,
            } as AtlAriaIconProps}
         >
         </atlantis-icon>
      `;
   };

   private _renderButton = () => {
      if (!this.showCtaButton) return nothing;

      return html`
         <atlantis-button
            variant=${ButtonEnums.ButtonVariant.Light}
            button-classes="banner-cta"
            @click=${() => this.dispatchEvent(new BannerEvents.BannerButtonClickEvent())}
         >
            ${this.ctaButtonText}
         </atlantis-button>
      `;
   };

   render() {
      return html`
         <div class="announcement-banner">
            <div class="banner-body-container">
               ${this._renderIcon()}
               <div class="banner-body">
                  <div>
                     ${this.bannerTitle
                        ? html`<div class="banner-title">
                             ${this.bannerTitle}
                          </div>`
                        : nothing}
                     <div class="banner-text">
                        <slot></slot>
                     </div>
                  </div>
               </div>
            </div>
            ${this._renderButton()}
         </div>
      `;
   }
}
